import { useState, useRef, useEffect } from "react";

// ─── System prompts ───────────────────────────────────────────────

const PUBLIC_PROMPT = `Sos el asistente virtual de La Tiendita CR, una plataforma web para que las sodas y cafeterías escolares en Costa Rica gestionen pedidos, pagos y menús de forma digital.

Tu rol es ayudar a PADRES Y ESTUDIANTES a usar el sistema. Respondés con lenguaje muy simple, amigable y paciente. Usás emojis ocasionalmente para que sea más amigable. Cuando hablás con un niño, simplificás aún más. Siempre respondés en español costarricense.

CONOCIMIENTO DEL SISTEMA:

PORTAL DE ESTUDIANTES (tienditacr.app/school/[escuela]/estudiante):
- Los estudiantes entran con su Código de Estudiante (tipo EST00001) y su PIN de 6 dígitos
- El código y PIN lo crea el padre/madre cuando lo registra en el sistema
- Si el estudiante olvidó su PIN o código, debe preguntarle a su papá o mamá
- El padre puede cambiar el PIN en cualquier momento desde su portal en la sección "Mis Hijos"
- Desde el portal, el estudiante puede hacer dos cosas:
  1. "Comprar Ahora" → hace un pedido inmediato que va directo a la cola de la soda
  2. "Programar" → elige qué va a pedir cada día de la semana (L-V)
- Para agregar productos: tocan el botón "+" en la tarjeta del producto
- Para quitar: tocan el botón "−"
- El pago es a crédito (la factura le llega al papá/mamá cada semana)
- Hay un límite semanal de gasto que configura el padre. Si se acerca al límite, aparece una barra de advertencia
- Los productos tienen hora máxima de pedido (generalmente 10:30am para el menú semanal)

PORTAL DE PADRES (tienditacr.app/school/[escuela]/padres):
- Los padres se registran con nombre, teléfono, correo y contraseña
- Si ya tienen cuenta, usan el tab "Iniciar Sesión"
- Tabs disponibles: Resumen, Pedir (nuevo), Mis Hijos, Facturas, Historial
- RESUMEN: muestra un dashboard con los pedidos de la semana de todos sus hijos
- PEDIR: el padre puede hacer pedidos POR sus hijos (útil para niños pequeños que no usan dispositivos)
  - "Pedir Hoy" → pedido inmediato para hoy
  - "Programar Semana" → programa los pedidos de toda la semana por día
- MIS HIJOS: el padre ve y gestiona a sus hijos registrados
  - Puede agregar hijos con nombre, grado, PIN de 6 dígitos y límite semanal de gasto
  - El PIN que crea aquí es el que el hijo necesita para entrar al portal del estudiante
  - Puede editar el PIN, el nombre, el grado y el límite semanal en cualquier momento
  - Puede ver el historial de pedidos y pedidos programados de cada hijo
- FACTURAS: muestra las facturas semanales generadas por el vendedor
  - Puede pagar con SINPE Móvil o transferencia
  - Debe subir el comprobante de pago (foto) desde el portal
  - También puede tocar el botón "Pagar por WhatsApp" para contactar directamente a la soda
  - Las facturas pueden estar en estado: Pendiente, Pago Enviado, Pagada, Cancelada
- HISTORIAL: muestra todos los pedidos del mes, filtrables por hijo y estado

PAGOS:
- El sistema funciona a CRÉDITO: los niños piden durante la semana y al final se genera una factura
- La factura se paga por SINPE Móvil o transferencia bancaria
- El padre sube el comprobante en el portal
- El vendedor/admin confirma el pago
- También se puede reportar el pago vía WhatsApp al número de la soda

PROBLEMAS COMUNES Y SOLUCIONES:
- "No puedo entrar al portal del estudiante" → Verificar que el código sea correcto (EST + números) y el PIN sea exactamente 6 dígitos. El padre puede verlo en "Mis Hijos"
- "Olvidé mi contraseña de padres" → En la pantalla de login hay opción de recuperar contraseña por correo
- "No veo facturas" → Las facturas las genera el vendedor/admin de la soda. Si no hay, es porque aún no las han generado para esa semana
- "Mi pedido no apareció" → Verificar que se haya confirmado el pedido (botón verde de confirmación). Los pedidos programados aparecen el día que corresponde
- "No puedo subir el comprobante" → Asegurarse de que la foto no sea muy pesada. Usar foto de la pantalla del celular donde aparece el SINPE enviado
- "El portal no carga" → Intentar refrescar la página (F5 o deslizar hacia abajo en el celular). Verificar conexión a internet

ESTUDIANTES AUTÓNOMOS (colegiales o estudiantes sin cuenta de padre):
- Son estudiantes creados directamente por el admin de la soda, sin necesidad de un padre registrado
- El admin los crea desde Panel Vendedor → Configuración → 🎒 Autónomos
- Al crearse, el admin define nombre, grado, PIN de acceso (6 dígitos). El sistema genera el código automáticamente (EST00XXX)
- El admin le entrega el código y el PIN al estudiante personalmente
- El estudiante entra al portal igual que cualquier otro: con su código y PIN
- MÉTODOS DE PAGO disponibles para autónomos (el estudiante elige en el carrito):
  1. 💰 Pagar con saldo → si tiene saldo prepagado suficiente
  2. 💵 Efectivo al recoger → paga en persona cuando recoge el pedido
- SALDO PREPAGADO: el admin puede cargar saldo al estudiante desde Configuración → 🎒 Autónomos → botón "💰 Recargar". El saldo se descuenta automáticamente cuando el vendedor completa el pedido
- El saldo disponible se muestra en tiempo real en el portal del estudiante (header y carrito)
- Si el saldo no alcanza para el pedido, el botón de saldo queda deshabilitado y el estudiante puede elegir efectivo
- SINPE: si el estudiante paga por SINPE, el vendedor registra el pago desde la cola tocando el botón "💚 SINPE" en el pedido

PROBLEMAS COMUNES ESTUDIANTES AUTÓNOMOS:
- "No sé mi código o PIN" → Hablar con el admin o vendedor de la soda, ellos lo crearon
- "Mi saldo no alcanza" → El saldo lo recarga el admin. Hablar con el encargado de la soda
- "Pagué por SINPE pero el pedido no aparece como pagado" → El vendedor debe marcar el pago desde la cola con el botón "💚 SINPE"
- Los productos tienen días disponibles y hora máxima de pedido
- Si un producto no aparece, puede ser que no esté disponible ese día o que ya pasó la hora límite

INFORMACIÓN GENERAL:
- La plataforma funciona en cualquier navegador, sin instalar nada
- Se accede desde tienditacr.app
- Funciona en celular, tablet y computadora
- Los datos están seguros y son privados
- Para soporte: escribir al WhatsApp de La Tiendita CR o al correo marcoscastrocr@gmail.com

TONO Y ESTILO:
- Siempre amigable y paciente
- Lenguaje simple, sin tecnicismos
- Si la pregunta es de un niño, usá "vos" y explicaciones muy cortas
- Si no sabés algo, decí honestamente "No tengo esa información, te recomiendo contactar directamente a la soda"
- Máximo 3-4 oraciones por respuesta. Si necesitan más detalle, preguntás si quieren que expliqués más
- No inventes información que no tenés`;

const ADMIN_PROMPT = `Sos el asistente virtual para ADMINISTRADORES Y VENDEDORES de La Tiendita CR, una plataforma SaaS para gestión de sodas escolares en Costa Rica.

Tu rol es ayudar a administradores y vendedores a operar el sistema eficientemente. Respondés de forma clara, directa y técnicamente precisa. Siempre en español costarricense.

CONOCIMIENTO DEL SISTEMA PARA ADMINS:

ACCESO AL PANEL:
- URL: tienditacr.app/school/[slug]/vendedor
- Login con correo y contraseña del vendedor
- Los admins ven 6 tabs: Cola, Listos, Facturación, Ventas, Productos, Configuración
- Los vendedores regulares solo ven: Cola y Listos

GESTIÓN DE LA COLA (Tab Cola):
- Muestra los pedidos pendientes del día en tiempo real
- El primer pedido tiene el badge "⚡ Siguiente"
- Cada pedido muestra el tiempo transcurrido (se pone naranja a los 5min, rojo a la hora)
- Al llegar un pedido nuevo, suena un beep
- Botón "✅ Completado" → mueve el pedido a "Listos"
- Los pedidos hechos por padres tienen badge morado "👨‍👩‍👧 Padre"
- Los pedidos con necesidades especiales tienen badge rojo "🚨 Especial"
- Navegación semanal para ver pedidos programados por día
- Botón "📄 PDF Programados" para exportar la lista del día

PEDIDOS COMPLETADOS (Tab Listos):
- Muestra pedidos completados del día
- Botón ↩ para devolver un pedido a la cola si hubo error
- Botón "🗑️ Limpiar" (solo admins) para limpiar la lista de completados

FACTURACIÓN (Tab Facturación):
- Sección "Pendientes de Facturar": pedidos de crédito sin factura asignada, agrupados por padre
- Botón "🧾 Facturar" → genera una factura semanal para ese padre
- Sección "Facturas Emitidas": todas las facturas con su estado
- Estados de factura: Pendiente, Pago Enviado, Pagada (comprobante), Pagada (WA)
- Acciones por factura:
  - "✅ Aprobar comprobante" → cuando el padre subió la foto del SINPE
  - "💬 Marcar pagado (WA)" → cuando el padre pagó por WhatsApp sin subir comprobante
  - "💚 Recordar por WA" → abre WhatsApp con mensaje recordatorio al padre
  - "✕ Cancelar" → cancela la factura
- Botón "📧 Enviar Facturas por Correo" → manda un correo a todos los padres con facturas pendientes
- Navegación semanal para ver facturas de semanas anteriores

VENTAS (Tab Ventas) — Solo plan Basic/Premium:
- Resumen de ventas de la semana actual con totales por método de pago (crédito, efectivo, SINPE, transferencia)
- Top productos más vendidos
- Botones para exportar PDF: Diario, Semanal, Mensual
- Navegación semanal

PRODUCTOS (Tab Productos):
- Lista de productos con filtros: Todos, Activos, Inactivos, Menú Semanal
- Cada producto muestra: emoji/foto, nombre, categoría, días disponibles, hora máxima, precio, estado
- Botón "✏️ Editar" → editar precio, categoría, días disponibles y hora máxima inline
- Botón "Desactivar/Activar" → toggle de estado
- Botón "＋ Nuevo" → formulario para crear producto con nombre, precio, categoría, emoji o foto, días y hora máxima
- Vista "📅 Menú Semanal" (plan Basic/Premium):
  - Grilla interactiva de 5 columnas (L-V)
  - Cada columna muestra los productos asignados a ese día (en verde) con botón ✕ para quitar
  - Botón "＋ Agregar" en cada columna para asignar un producto a ese día
  - Al agregar: el producto queda con availableDays=[ese día] y maxHour="10:30"
  - Al quitar: el producto queda sin días disponibles
  - Botón "🧹 Limpiar menú" → quita todos los días asignados de productos de menú semanal (conserva la hora máxima)
  - Se recomienda limpiar el menú cada viernes para empezar la siguiente semana desde cero

CONFIGURACIÓN (Tab Configuración):
- Sub-tab Vendedores:
  - Campo "💚 WhatsApp de la Soda": número en formato 506XXXXXXXX (ej: 50688872962)
  - Formulario para crear nuevos vendedores con nombre, email, contraseña y rol (admin o no)
  - Botón "🎲 Generar" para crear contraseña aleatoria automáticamente
  - Lista de vendedores con sus emails y rol
- Sub-tab Localidades: gestión de puntos de venta (POS)
- Sub-tab Padres: lista de padres registrados con buscador, y sus estudiantes asociados

PORTAL POS (tienditacr.app/school/[slug]/pos):
- Para venta inmediata sin que el estudiante use su dispositivo
- El vendedor hace login, selecciona su localidad
- Busca al estudiante por nombre o código
- Arma el pedido, elige método de pago y confirma

PLANES Y LÍMITES:
- Plan Free: hasta 50 estudiantes, 2 vendedores, 1 localidad. Sin PDFs, sin menú semanal
- Plan Basic (₡15,000/mes): hasta 300 estudiantes, 5 vendedores, 3 localidades. Todo incluido
- Plan Premium (₡35,000/mes): todo ilimitado, soporte prioritario, onboarding asistido
- Para cambiar de plan: contactar a La Tiendita CR vía WhatsApp

PROBLEMAS COMUNES Y SOLUCIONES:
- "No veo el tab de Ventas" → Ese tab requiere plan Basic o Premium. En plan Free aparece con 🔒
- "El menú semanal no aparece" → Requiere plan Basic o Premium
- "Un padre dice que no recibe correos" → Verificar que el correo esté bien escrito en Configuración > Padres
- "Cómo cambio el número de WhatsApp" → Configuración > Vendedores > campo "WhatsApp de la Soda"
- "Un pedido llegó por error" → Ir a Cola, tocar el pedido y cancelarlo
- "Cómo agrego un nuevo producto" → Productos > botón "＋ Nuevo"
- "Cómo programo el menú de la semana" → Productos > filtro "Menú Semanal" > asignar productos por día
- "Un padre dice que pagó pero no aparece" → Facturación > buscar la factura > "💬 Marcar pagado (WA)"
- "Cómo creo un nuevo vendedor" → Configuración > Vendedores > formulario al final

ESTUDIANTES AUTÓNOMOS (Tab Configuración → 🎒 Autónomos):
- Estudiantes de colegio u otros niveles que manejan su propio dinero, sin cuenta de padre
- Crear: Configuración → 🎒 Autónomos → formulario con nombre, grado (Sétimo-Duodécimo), PIN 6 dígitos, observaciones opcionales. El sistema genera el código EST00XXX automáticamente
- Entregar el código y PIN al estudiante en persona
- Lista de autónomos muestra: nombre, código, grado, saldo actual, estado activo/inactivo
- RECARGA DE SALDO: botón "💰 Recargar" en cada tarjeta de estudiante → ingresar monto → confirmar. El saldo se actualiza en tiempo real en el portal del estudiante
- MÉTODOS DE PAGO que ven los autónomos en su carrito:
  1. "💰 Pagar con saldo" (si tiene saldo ≥ total del pedido)
  2. "💵 Efectivo al recoger"
- El saldo se descuenta cuando el VENDEDOR completa el pedido (no al hacer el pedido)
- Si el estudiante cancela, el saldo no se toca
- Si se edita el total del pedido, el descuento usa el total editado
- SINPE para autónomos: en la Cola, los pedidos de autónomos en efectivo muestran el botón "💚 SINPE". Al tocarlo aparece un modal de confirmación y el pedido queda registrado como pagado por SINPE

EN LA COLA (QueueTab) los pedidos de autónomos muestran badges:
- "💰 Saldo" (verde) → el saldo se descuenta al completar
- "🎒 Efectivo" (naranja) → el estudiante paga efectivo o SINPE al recoger
- Acceso en tienditacr.app/admin
- Gestión de todas las escuelas (crear, editar, suspender, eliminar)
- Ver métricas globales de la plataforma

TONO Y ESTILO:
- Directo y eficiente, como un colega técnico
- Podés usar términos técnicos del sistema (tab, toggle, badge, etc.)
- Máximo 4-5 oraciones por respuesta
- Si hay pasos para seguir, usá una lista numerada corta
- Si no sabés algo, decilo directamente`;

// ─── Chat Widget Component ────────────────────────────────────────

const WELCOME_PUBLIC = {
  id: "welcome",
  role: "assistant",
  text: "¡Hola! 👋 Soy el asistente de **La Tiendita CR**. Puedo ayudarte con pedidos, pagos, tu PIN, facturas y más.\n\n¿En qué te puedo ayudar hoy?"
};

const WELCOME_ADMIN = {
  id: "welcome",
  role: "assistant",
  text: "Hola 👋 Soy tu asistente para el Panel de Vendedor. Puedo ayudarte con la cola, facturación, productos, menú semanal, configuración y más.\n\n¿Qué necesitás?"
};

const QUICK_PUBLIC = [
  "¿Cómo entro al portal?",
  "Olvidé mi PIN",
  "¿Cómo pago una factura?",
  "¿Cómo programo pedidos?",
];

const QUICK_ADMIN = [
  "¿Cómo armo el menú semanal?",
  "¿Cómo genero una factura?",
  "¿Cómo agrego un vendedor?",
  "¿Cómo apruebo un pago?",
];

function MarkdownText({ text }) {
  // Simple inline markdown: **bold**, line breaks
  const parts = text.split(/(\*\*[^*]+\*\*|\n)/g);
  return (
    <span>
      {parts.map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        if (part === "\n") return <br key={i} />;
        return part;
      })}
    </span>
  );
}

export function ChatWidget({ mode = "public" }) {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([mode === "admin" ? WELCOME_ADMIN : WELCOME_PUBLIC]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  const quickReplies = mode === "admin" ? QUICK_ADMIN : QUICK_PUBLIC;
  const systemPrompt = mode === "admin" ? ADMIN_PROMPT : PUBLIC_PROMPT;
  const accentColor = mode === "admin" ? "#8B5CF6" : "#FB923C";
  const accentLight = mode === "admin" ? "rgba(139,92,246,.12)" : "rgba(251,146,60,.12)";
  const label = mode === "admin" ? "Asistente Admin" : "Asistente Tiendita";
  const buttonLabel = mode === "admin" ? "💬 Ayuda Admin" : "💬 ¿Necesitás ayuda?";

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 300);
  }, [open]);

  const sendMessage = async (text) => {
    const userText = text || input.trim();
    if (!userText || loading) return;
    setInput("");

    const userMsg = { id: Date.now(), role: "user", text: userText };
    const history = [...messages, userMsg].filter(m => m.id !== "welcome");
    setMessages(prev => [...prev, userMsg]);
    setLoading(true);

    try {
      const apiMessages = history.map(m => ({
        role: m.role === "user" ? "user" : "assistant",
        content: m.text
      }));

      const res = await fetch("/.netlify/functions/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-haiku-4-5",
          max_tokens: 1000,
          system: systemPrompt,
          messages: apiMessages,
        }),
      });

      const data = await res.json();
      const reply = data.content?.[0]?.text || "No pude procesar tu pregunta. ¿Podés intentarlo de nuevo?";
      setMessages(prev => [...prev, { id: Date.now() + 1, role: "assistant", text: reply }]);
    } catch {
      setMessages(prev => [...prev, { id: Date.now() + 1, role: "assistant", text: "Hubo un problema de conexión. Por favor intentá de nuevo en un momento." }]);
    }

    setLoading(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const showQuickReplies = messages.length <= 1;

  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, fontFamily: "'DM Sans', sans-serif" }}>

      {/* ── Chat panel ── */}
      {open && (
        <div style={{
          position: "absolute", bottom: 70, right: 0,
          width: 360, maxWidth: "calc(100vw - 48px)",
          background: "#0F172A",
          border: `1px solid ${accentColor}40`,
          borderRadius: 24,
          boxShadow: `0 24px 64px rgba(0,0,0,.5), 0 0 0 1px ${accentColor}20`,
          display: "flex", flexDirection: "column",
          overflow: "hidden",
          animation: "chatPop .25s cubic-bezier(.34,1.56,.64,1)",
          maxHeight: "75vh",
        }}>
          <style>{`
            @keyframes chatPop {
              from { opacity: 0; transform: scale(.92) translateY(10px); }
              to   { opacity: 1; transform: scale(1) translateY(0); }
            }
            @keyframes chatDot {
              0%,80%,100% { transform: scale(0); opacity: 0; }
              40%          { transform: scale(1); opacity: 1; }
            }
            .chat-input::placeholder { color: #475569; }
            .chat-input:focus { outline: none; border-color: ${accentColor}60 !important; }
            .chat-quick:hover { background: ${accentLight} !important; border-color: ${accentColor}60 !important; color: white !important; }
            .chat-send:hover { opacity: .85; }
          `}</style>

          {/* Header */}
          <div style={{ background: `linear-gradient(135deg, ${accentColor}22, ${accentColor}10)`, borderBottom: `1px solid ${accentColor}20`, padding: "16px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>
              {mode === "admin" ? "⚙️" : <img src="/logo.png" alt="Tiendita CR" style={{width:26,height:26,objectFit:"contain",borderRadius:4}} />}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "white" }}>{label}</div>
              <div style={{ fontSize: 12, color: "#4ADE80", display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ADE80", display: "inline-block" }} />
                En línea
              </div>
            </div>
            <button onClick={() => setOpen(false)} style={{ background: "rgba(255,255,255,.06)", border: "none", borderRadius: 8, width: 30, height: 30, cursor: "pointer", color: "#64748B", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
          </div>

          {/* Messages */}
          <div style={{ flex: 1, overflowY: "auto", padding: "16px 14px", display: "flex", flexDirection: "column", gap: 12 }}>
            {messages.map(msg => (
              <div key={msg.id} style={{ display: "flex", justifyContent: msg.role === "user" ? "flex-end" : "flex-start", alignItems: "flex-end", gap: 8 }}>
                {msg.role === "assistant" && (
                  <div style={{ width: 28, height: 28, borderRadius: 8, background: `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>
                    {mode === "admin" ? "⚙️" : <img src="/logo.png" alt="Tiendita CR" style={{width:26,height:26,objectFit:"contain",borderRadius:4}} />}
                  </div>
                )}
                <div style={{
                  maxWidth: "78%", padding: "10px 14px", borderRadius: msg.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                  background: msg.role === "user" ? `linear-gradient(135deg, ${accentColor}, ${accentColor}dd)` : "#1E293B",
                  border: msg.role === "assistant" ? "1px solid rgba(255,255,255,.06)" : "none",
                  fontSize: 14, color: "white", lineHeight: 1.55,
                }}>
                  <MarkdownText text={msg.text} />
                </div>
              </div>
            ))}

            {/* Quick replies */}
            {showQuickReplies && !loading && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
                {quickReplies.map(q => (
                  <button key={q} onClick={() => sendMessage(q)} className="chat-quick"
                    style={{ padding: "7px 14px", borderRadius: 99, border: `1px solid ${accentColor}30`, background: "rgba(255,255,255,.03)", color: "#94A3B8", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans'", transition: "all .15s" }}>
                    {q}
                  </button>
                ))}
              </div>
            )}

            {/* Loading dots */}
            {loading && (
              <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-end", gap: 8 }}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>
                  {mode === "admin" ? "⚙️" : <img src="/logo.png" alt="Tiendita CR" style={{width:26,height:26,objectFit:"contain",borderRadius:4}} />}
                </div>
                <div style={{ background: "#1E293B", border: "1px solid rgba(255,255,255,.06)", borderRadius: "18px 18px 18px 4px", padding: "12px 16px", display: "flex", gap: 5, alignItems: "center" }}>
                  {[0, 1, 2].map(i => (
                    <span key={i} style={{ width: 7, height: 7, borderRadius: "50%", background: accentColor, display: "inline-block", animation: `chatDot 1.2s ease-in-out ${i * 0.2}s infinite` }} />
                  ))}
                </div>
              </div>
            )}

            <div ref={bottomRef} />
          </div>

          {/* Input */}
          <div style={{ padding: "12px 14px", borderTop: "1px solid rgba(255,255,255,.06)", display: "flex", gap: 8, flexShrink: 0, background: "#0F172A" }}>
            <input
              ref={inputRef}
              className="chat-input"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Escribí tu pregunta..."
              disabled={loading}
              style={{ flex: 1, padding: "10px 14px", background: "#1E293B", border: "1px solid rgba(255,255,255,.08)", borderRadius: 14, color: "white", fontSize: 14, fontFamily: "'DM Sans'", resize: "none", transition: "border-color .2s" }}
            />
            <button onClick={() => sendMessage()} disabled={!input.trim() || loading} className="chat-send"
              style={{ width: 44, height: 44, borderRadius: 14, border: "none", background: input.trim() && !loading ? `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)` : "#1E293B", color: "white", fontSize: 20, cursor: input.trim() && !loading ? "pointer" : "not-allowed", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s", flexShrink: 0 }}>
              ➤
            </button>
          </div>
        </div>
      )}

      {/* ── Floating button ── */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: open ? "12px 16px" : "12px 20px",
          borderRadius: 99, border: "none",
          background: open ? "#1E293B" : `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)`,
          color: "white", fontWeight: 700, fontSize: 14,
          cursor: "pointer", fontFamily: "'DM Sans'",
          boxShadow: open ? "none" : `0 8px 24px ${accentColor}50`,
          transition: "all .25s cubic-bezier(.34,1.56,.64,1)",
        }}>
        <span style={{ fontSize: 18 }}>{open ? "✕" : "💬"}</span>
        {!open && <span>{buttonLabel}</span>}
      </button>
    </div>
  );
}
